import { styles } from "@repo/helpers";
import { useMemo } from "react";

import { MapMarker } from "../../../../components/GoogleMap/types";
import MapSale from "../../../../models/mapSale";
import style from "./style.module.scss";

export default function RecentEnrollmentMarker(props: MarkerProps) {
	const { sale, active, hover } = props;
	const isSale = sale.enrollmentID;
	//HACK - just pulling global customer name from TLP DOM
	const customer = (window as any)._customerName ?? "TLP";
	const flagStyle = useMemo(
		() =>
			isSale
				? { backgroundImage: "url( '/images/" + customer + "/salesflag.png' )" }
				: { backgroundImage: "url('/Content/MyView/tabletmarker.png')" },
		[isSale],
	);
	const markerStyle = styles(style.marker, active && style.active, hover && style.hover);
	return (
		<>
			<div
				title={sale.enrollmentID as any}
				className={markerStyle}
				style={flagStyle}
				onClick={props.onClick}
				onMouseEnter={props.onHover(true)}
				onMouseLeave={props.onHover(false)}
			></div>
			{(active || hover) && <div style={{ width: 100, height: 100 }}>{props.text}</div>}
		</>
	);
}

export interface MarkerProps extends MapMarker {
	sale: MapSale;
	active?: boolean;
	hover?: boolean;
	onClick: () => void;
	onHover: (active: boolean) => () => void;
}
